import { ReactNode } from 'react';
import { useFormTableErrors } from './TanstackFormTable';
import { Badge, Flex } from 'antd';

interface ErrorHeaderProps {
  columnCode: string;
  children: ReactNode;
}

export const ErrorHeader: React.FC<ErrorHeaderProps> = ({
  columnCode,
  children,
}) => {
  const errorInfo = useFormTableErrors();
  const errorCount = errorInfo?.columnErrorCounts.get(columnCode) || 0;

  return (
    <Flex align="center" gap="small">
      {children}
      <Badge count={errorCount} showZero={false} />
    </Flex>
  );
};
